
<div fxLayout="column" fxLayoutAlign="center center" fxFill>
<div fxLayout="row">
    Secure Home
</div>
</div>
